import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { isNil, replace } from 'lodash';
import { Luminaire } from './../../models/energiekarte/luminaire';
import { CountedStreetLightResponse } from '@app/socket-service-page/models/streetlights/streetlight';
import { LuminaireCategory } from '@app/shared/models/luminaire-category/luminaire-category';

@Injectable({
  providedIn: 'root',
})
export class StreetlightApiService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  baseUri = 'socrates/streetlights/api/municipalities/{0}/streetlights';

  public getStreetlightsByMunicipalityKey(municipalityKey: string, q?: string): Observable<any[]> {
    const uri = replace(this.baseUri, '{0}', municipalityKey);
    return this.http.get<any[]>(this.endpoint(uri, q));
  }

  public getStreetlightsDamageReports(municipalityKey: string, queryOptions: string): Observable<CountedStreetLightResponse> {
    const uri = replace(this.baseUri, '{0}', municipalityKey);
    return this.http.get<CountedStreetLightResponse>(this.endpoint(uri, queryOptions));
  }

  public getLuminairesByMunicipalityKey(municipalityKey: string, q?: any): Observable<Luminaire[]> {
    const params = !isNil(q) ? { params: q } : { params: '' };
    return this.http.get<Luminaire[]>(this.endpoint(`api/municipalities/${municipalityKey}/luminaires`), params);
  }

  public getLuminaireCategories(): Observable<LuminaireCategory[]> {
    const url = `socrates/streetlights/api/references/luminairecategories?$orderby=name`;
    return this.http.get<LuminaireCategory[]>(this.endpoint(url));
  }
}
